import { HYDRATE } from 'next-redux-wrapper';
import { combineReducers } from 'redux';
import popupManagerReducer from './popup-manager/reducer';
import tryRoomvuVideoReducer from './tryRoomvuVideo/reducer';
import userReducer from './user/reducer';
import userRegisterReducer from './userRegister/reducer';
import videoReducer from './video/reducer';
import detectDeviceReducer from './detectDevice/slice';

const combinedReducer = combineReducers({
  video: videoReducer,
  popupManager: popupManagerReducer,
  tryRoomvuVideo: tryRoomvuVideoReducer,
  userRegister: userRegisterReducer,
  user: userReducer,
  detectDevice: detectDeviceReducer,
});

const rootReducer = (state, action) => {
  if (action.type === HYDRATE) {
    return {
      ...state, // use previous state
      ...action.payload, // apply delta from hydration
    };
  } else {
    return combinedReducer(state, action);
  }
};

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
